import _ from 'lodash'
import { useMemo } from 'react'
import { useGetNetworksQuery } from '@/core/services/network'
import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { isExpertiseOrder } from '@/utils/type-guards'

export function useGetNetworkCards() {
  const authUser = useAppSelector(selectAuthUser)

  const { data: networks, refetch: refetchNetworks } = useGetNetworksQuery({}, { refetchOnMountOrArgChange: true })

  const networkCards = useMemo(
    () =>
      networks?.map((network) => ({
        id: network._id,
        coverPhoto: network.coverPhoto?.url,
        joined: !!network.members.find((member) => member === authUser?._id),
        memberCount: network.members.length,
        name: network.name,
        pendingOrders: [
          {
            count: _.filter(network.pendingOrders, isExpertiseOrder).length,
            type: 'expertise' as const,
          },
        ],
        privacy: network.privacy,
      })) ?? [],
    [networks, authUser]
  )

  return { networks, networkCards, refetchNetworks }
}
